const FALLBACK_WORKER_URL = "https://bufferbloat-staging.waveform.workers.dev";

export const getPublicUrl = () => {
  // Browsers have no `process` global either: react-scripts only substitutes
  // literal `process.env.PUBLIC_URL` expressions at build time. Only the
  // Cloudflare Worker bundle (built by wrangler, no substitution) has neither
  // `process` nor `window`, and must not evaluate `process.env` at all.
  if (typeof process === 'undefined' && typeof window === 'undefined') {
    return FALLBACK_WORKER_URL;
  }
  return process.env.PUBLIC_URL || FALLBACK_WORKER_URL;
};

export const EnvConfiguration = {
  WORKER_URL: getPublicUrl()
  //WORKER_URL: "http://127.0.0.1:8787"
};
